"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _Value = _interopRequireDefault(require("./Value"));

var _Row = _interopRequireDefault(require("./Row"));

var _Key = _interopRequireDefault(require("./Key"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DisplayTable = function DisplayTable(_ref) {
  var className = _ref.className,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["className", "children"]);

  return /*#__PURE__*/_react.default.createElement(StyledDisplayTable, _extends({}, otherProps, {
    className: className
  }), /*#__PURE__*/_react.default.createElement(StyledBody, null, children));
};

var StyledDisplayTable = _styledComponents.default.table.withConfig({
  displayName: "StyledDisplayTable"
})(["width:100%;font-family:", ";font-size:1.6rem;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var StyledBody = _styledComponents.default.tbody.withConfig({
  displayName: "StyledBody"
})(["background-color:white;"]);

DisplayTable.defaultProps = {
  otherProps: {}
};
DisplayTable.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,
  children: _propTypes.node
};
DisplayTable.Value = _Value.default;
DisplayTable.Value.displayName = 'DisplayTable.Value';
DisplayTable.Row = _Row.default;
DisplayTable.Row.displayName = 'DisplayTable.Row';
DisplayTable.Key = _Key.default;
DisplayTable.Key.displayName = 'DisplayTable.Key';
var _default = DisplayTable;
exports.default = _default;